<div [ngClass]="{'d-none': navbarFixed, 'd-flex': !navbarFixed}"
    class="d-flex d-lg-none bg-lightpurple py-1 px-2 justify-content-center align-items-center">
    <a href="tel:699 184 190" class="d-lg-flex justify-content-end align-items-center text-decoration-none"
        style="white-space: nowrap;">
        <fa-icon size="sm" [icon]="phone" class="mr-2 text-lightblue"></fa-icon>
        <span class="text-decoration-none text-darkgray" href=" tel:854 99 31 64">854 99 31 64</span> - <span
            class="text-decoration-none text-darkgray" href=" tel:854 99 31 64">699 184 190</span>
    </a>
    <a href="mailto:info@playbots.es" target="_blank" class="mx-2">
        <fa-icon [icon]="mail" class="mx-1 text-lightblue"></fa-icon>
        <span class="text-darkgray">info@playbots.es</span>
    </a>
</div>
<div class="d-none d-lg-flex justify-content-end bg-lightpurple p-1">
    <div class="container container-masterhead p-0">
        <div class="d-flex justify-content-end">
            <div class="col-9">
                <div class="d-none d-lg-flex justify-content-center align-items-center">
                    <div class="d-flex col-12 col-lg-6 text-center justify-content-end">
                        <a href="https://www.instagram.com/playbotseducation" target="_blank"
                            class="headerMail headerMobile rounded-5 bg-black d-flex flex-column justify-content-center align-items-center mx-2 pt-1">
                            <fa-icon [icon]="instagram" size="md" class="text-white"></fa-icon>
                        </a>
                        <a href="https://www.facebook.com/playbotseducation" target="_blank"
                            class="headerMail headerMobile rounded-5 bg-black d-flex flex-column justify-content-center align-items-center mx-2 pt-1">
                            <fa-icon [icon]="facebook" size="md" class="text-white"></fa-icon>
                        </a>
                        <a href="https://twitter.com/playbotsedu" target="_blank"
                            class="headerMail headerMobile rounded-5 bg-black d-flex flex-column justify-content-center align-items-center mx-2 pt-1">
                            <fa-icon [icon]="twitter" size="md" class="text-white"></fa-icon>
                        </a>
                    </div>
                    <div class="col-12 col-lg-6 text-center">
                        <div class="d-lg-flex flex-nowrap text-decoration-none">
                            <div class="mx-2">
                                <fa-icon [icon]="phone" class="mr-2 text-lightblue"></fa-icon>
                                <a href="tel:854 99 31 64" class="text-decoration-none text-darkgray">854 99 31 64</a> -
                                <a href="tel:699 184 190" class="text-decoration-none text-darkgray">699 184 190</a>
                            </div>
                            <div class="mx-2">
                                <fa-icon [icon]="mail" class="mx-1 text-lightblue"></fa-icon>
                                <a href="mailto:info@playbots.es" target="_blank"
                                    class="text-darkgray">info@playbots.es</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<div class="container container-masterhead p-0">
    <!-- Toolbar de escritorio -->
    <div class="d-none d-lg-flex align-items-center justify-content-center pt-3">
        <div class="col-3 mr-3">
            <a href="https://www.playbots.es">
                <img src="../../assets/img/logo.png" class="ml-3 w-100">
            </a>
        </div>
        <div class="col-9">
            <div class="d-none d-lg-flex mt-3">
                <div class="col-12 text-right" id="secondary-menu-container">
                    <div class="d-none d-lg-flex justify-content-center align-items-center">
                        <ul class="list-unstyled d-inline-flex mb-0">
                            <li *ngFor="let item of secondaryMenu" class="my-0">
                                <a [href]="item.ref" class="px-3 text-black">{{item.label}}</a>
                            </li>
                        </ul>
                        <a href="/registro"
                            class="ml-4 btn btn-lg no-border-radius vag-bold-font btn-secondary">Regístrate</a>

                    </div>
                </div>
            </div>
        </div>
    </div>


    <!-- Toolbar móvil -->
    <div class="d-flex d-lg-none justify-content-between align-items-center bg-white py-3" (scroll)="onScroll()"
        [ngClass]="{'fixed-top': navbarFixed}">
        <div class="col-5 px-0">
            <a href="https://www.playbots.es">
                <img src="../../assets/img/logo.png" class="ml-3 w-100">
            </a>
        </div>
        <div class="col-6 text-center">
            <a href="/registro"
                class="btn btn-md no-border-radius vag-bold-font btn-secondary text-uppercase">Regístrate</a>
        </div>
        <div class="col-1 mt-2">
            <button mat-icon-button class="example-icon d-lg-none float-right"
                aria-label="Example icon-button with menu icon" (click)="mobileShowMenu = !mobileShowMenu">
                <!-- <mat-icon>menu</mat-icon> -->
                <fa-icon size="2x" [icon]="mobileShowMenu ? menuOpen : menu" class="mr-2"></fa-icon>
            </button>
        </div>

    </div>
    <div *ngIf="mobileShowMenu" class="d-block d-lg-none" style="z-index: 999;" id="mobile-menu">
        <ul class="list-unstyled d-block mb-4">
            <li *ngFor="let item of primaryMenu" class="my-0 p-3 border-bottom border-white text-uppercase"
                [ngClass]="{'dropdown': item.childs}">
                <a class="px-3 text-decoration-none text-white" [ngClass]="{'dropdown-toggle': item.childs}"
                    [href]="item.ref" id="navbarDropdownMenuLink" [attr.data-toggle]="item.childs ? 'dropdown' : null"
                    aria-haspopup="true" aria-expanded="false">
                    {{item.label}}
                </a>
                <div *ngIf="item.childs" class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a class="dropdown-item" *ngFor="let child of item.childs" [href]="child.ref">{{child.label}}</a>
                </div>
            </li>
            <li *ngFor="let item of secondaryMenu" class="my-0 p-3 border-bottom border-white text-uppercase">
                <a [href]="item.ref" class="px-3 text-decoration-none text-white">{{item.label}}</a>
            </li>
        </ul>
    </div>
</div>
<div id="primary-menu-container" class="mt-3 bg-black text-center">
    <nav id="site-navigation" class="text-center">
        <ul class="d-none d-lg-inline-flex list-unstyled">
            <a *ngFor="let item of primaryMenu" [routerLink]="item.ref" routerLinkActive="active"
                class="text-white {{item.bgHover}}" [ngClass]="{'nav-item dropdown': item.childs}"
                [routerLinkActiveOptions]="{exact: true}">
                <li class="px-5 text-uppercase" [ngClass]="{'dropdown-toggle': item.childs}">
                    <span>{{item.label}}</span>
                    <ul *ngIf="item.childs" class="dropdown-menu bg-black list-unstyled">
                        <li class="px-4 nav-link" *ngFor="let child of item.childs" [ngClass]="child.bgHover">
                            <a [routerLink]="child.ref" class="text-white text-decoration-none">{{child.label}}</a>
                        </li>
                    </ul>
                </li>
            </a>
        </ul>
    </nav>
</div>